import Vue from "vue";

export const LayoutEditorEventBus = new Vue({
	data() {
		return {
			mouseX: 0,
			mouseY: 0,
			zoomLevel: 1,
			dragging: false,
		};
	},
	methods: {
		mouseMove(x: number, y: number) {
			this.mouseX = x / this.zoomLevel;
			this.mouseY = y / this.zoomLevel;
			this.$emit("mouse-move", {x: this.mouseX, y: this.mouseY});
		},
		mouseUp() {
			this.$emit("mouse-up");
		}
	}
});